import KnowledgeBasesContext from "../../../context/KnowledgeBasesContext";
import React, { useState, useEffect } from 'react';
import Accordion, { AccordionItem } from '../../@base/Accordion';
import Input from '../../@base/Input';
import styles from "../SharedStyle.module.css";
import { useContext } from "react";
import '../../../assets/dsgov/css/components/item.css';
import ReactHtmlParser from 'react-html-parser';
import {
  getParameter, handleInputValid, onValidHandler, preparingInput, Validation,
} from '../Commons';

/**
 * Componente responsável pelo GPT.
 * Exibe as propriedades a todas as bases de conhecimento do chatbot.
 * 
 * @param {*} props 
 * @returns 
 */
export const GPTComponent = (props) => {
  if (!props.component.parameters) return null;
  
  const component = props.component;
  const knowledgeBasesContext = useContext(KnowledgeBasesContext);
  const parameterList = component.parameters;
  const [inputValid, setInputValid] = useState({});
  const [knowledgeBases, setKnowledgeBases] = useState([]);

  useEffect(() => {
    handleInputValid(inputValid, props);
  }, [inputValid]);

  // Carregar todas as bases de conhecimento sempre
  // que houver mudanças nos parâmetros.
  useEffect(() => {
    fetchKnowledgeBases();
  }, [props.component.parameters]);
  
  useEffect(() => {
    props.setHelperContent(
      <div>
        {ReactHtmlParser(props.component.description)}
      </div>,
    );
  }, []);

  /**
   * Obter todos os parâmetros "estáticos" do GPT.
   */
  const urlParam = getParameter(
    parameterList,
    "gpt.azure.openai.url",
  );

  const apiKeyParam = getParameter(
    parameterList,
    "gpt.azure.openai.api-key",
  );

  const apiVersionParam = getParameter(
    parameterList,
    "gpt.azure.openai.api-version",
  );

  const deploymentIdParam = getParameter(
    parameterList,
    "gpt.azure.openai.deployment-id",
  );

  /**
   * Carrega todas as bases de conhecimento e as coloca
   * no estado do componente.
   * 
   * Verifica quais as bases que já estão associadas ao bot
   * para exibir já marcada.
   */
  const fetchKnowledgeBases = async () => {
    const knowledgeBases = await knowledgeBasesContext.fetch();
    
    knowledgeBases.forEach((knowledgeBase) => {
      knowledgeBase.checked = component.knowledgeBases.findIndex((k) => k.id === knowledgeBase.id) > -1;
    });
    
    setKnowledgeBases(knowledgeBases);
  };
  
  /**
   * Trata o evento que é lançado quando o valor de um parâmetro é modificado.
   * Altera o valor do parâmetro informado.
   *
   * @param parameter Paramêtro que deve ser atualizado.
   * @param evento Evento HTML que chamou esse handler.
   */
  const handleParameterValueChange = (parameter, event) => {
    props.updateParameter({
      ...parameter,
      value: event.target.value
    });
  };

  /**
   * Trata o evento de clique no checkbox das bases de conhecimento.
   * Armazena as bases de conhecimento selecionadas.
   * 
   * @param {*} event 
   * @param {*} knowledgeBase 
   */
  const handleChangeKnowledgeBaseUse = (event, knowledgeBase) => {
    component.knowledgeBases = [];
    knowledgeBase.checked = event.target.checked;
    
    knowledgeBases.forEach((kb) => {
      if (kb.checked) {
        component.knowledgeBases.push(kb);
      }
    });

    const index = knowledgeBases.findIndex((kb) => kb.id === knowledgeBase.id);
    const newKnowledgeBases = [...knowledgeBases];
    
    newKnowledgeBases.splice(index, 1, knowledgeBase);

    setKnowledgeBases(newKnowledgeBases);
  };

  return (
    <>
      <Accordion>
        <AccordionItem active>
          <div>Bases de Conhecimento</div>
          <div style={{marginLeft: '20px'}}>
            <small>Selecione as bases de conhecimento que gostaria de associar ao GPT.</small>
            {knowledgeBases.map((knowledgeBase) => ( 
              <div key={knowledgeBase.id} className="br-item" data-toggle="selection">
                <div className="br-checkbox">
                  <input checked={knowledgeBase.checked} id={knowledgeBase.id} name={knowledgeBase.id} type="checkbox" onChange={(event) => handleChangeKnowledgeBaseUse(event, knowledgeBase)}/>
                  <label htmlFor={knowledgeBase.id}>{knowledgeBase.name}</label>
                </div>
              </div>
            ))}

            {knowledgeBases.length <= 0 ? <div>Nenhuma base de conhecimento cadastrada para esse chatbot.</div> : null}
          </div>
        </AccordionItem>
        <AccordionItem active>
          <div>Configurações </div>
          <div className={styles.ComponentSubList} style={{ textAlign: 'left' }}>
            <div className="item-list">
              <div>
                {preparingInput(<Input
                    label="Chave da API"
                    placeholder="Digite a chave da API"
                    labelWidth={190}
                    width={350}
                    inline
                    title={apiKeyParam.parameter.hint}
                  />, apiKeyParam, props, onValidHandler(setInputValid, apiKeyParam)
                )}
              </div>
            </div>
            <div className="item-list">
              <div>
                {preparingInput(<Input
                    label="Versão da API"
                    placeholder="Digite a versão da API que deve ser usada para a conexão"
                    labelWidth={190}
                    width={350}
                    inline
                    title={apiVersionParam.parameter.hint}
                  />, apiVersionParam, props, onValidHandler(setInputValid, apiVersionParam)
                )}
              </div>
            </div>
            <div className="item-list">
              <div>
                {preparingInput(<Input
                    label="URL da API"
                    placeholder="Digite a URL da API que deve ser usada para a conexão"
                    labelWidth={190}
                    width={350}
                    inline
                    title={urlParam.parameter.hint}
                  />, urlParam, props, onValidHandler(setInputValid, urlParam)
                )}
              </div>
            </div>
            <div className="item-list">
              <div>
                {preparingInput(<Input
                    label="ID do Modelo"
                    placeholder="Digite o identificador do modelo publicado na nuvem da Azure"
                    labelWidth={190}
                    width={350}
                    inline
                    title={deploymentIdParam.parameter.hint}
                  />, deploymentIdParam, props, onValidHandler(setInputValid, deploymentIdParam)
                )}
              </div>
            </div>
          </div>
        </AccordionItem>
        {props.localizationAccordionItem || null}
      </Accordion >
    </>
  );
};

export default GPTComponent;
